import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Calendar } from "../../components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import { CalendarIcon, Clock, Phone, Bell, Check } from "lucide-react";
import { format } from "date-fns";

const DueFollowupDialog = ({
  showDueFollowupPopup,
  setShowDueFollowupPopup,
  dueFollowup,
  rescheduleDate,
  setRescheduleDate,
  rescheduleTime,
  setRescheduleTime,
  handleRescheduleFollowup,
  handleCompleteFollowup,
  handleClickToCall,
  lead
}) => {
  return (
    <Dialog open={showDueFollowupPopup} onOpenChange={setShowDueFollowupPopup}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-orange-600">
            <Bell className="w-5 h-5" />
            Follow-up Due!
          </DialogTitle>
          <DialogDescription>
            You have a follow-up that requires your attention
          </DialogDescription>
        </DialogHeader>
        {dueFollowup && (
          <div className="space-y-4 mt-4">
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
              <h4 className="font-semibold text-slate-900">{dueFollowup.title}</h4>
              {dueFollowup.description && (
                <p className="text-sm text-slate-600 mt-1">{dueFollowup.description}</p>
              )}
              <div className="flex items-center gap-2 mt-2">
                <Clock className="w-4 h-4 text-orange-500" />
                <span className="text-sm text-orange-600 font-medium">
                  Scheduled: {new Date(dueFollowup.scheduled_at).toLocaleDateString()} at {new Date(dueFollowup.scheduled_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
            </div>

            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-2">
                  <Label className="text-sm">Reschedule Date</Label>
                  <Popover>
                    <PopoverTrigger asChild>
                      <Button variant="outline" className="w-full justify-start text-sm" size="sm">
                        <CalendarIcon className="w-4 h-4 mr-2" />{format(rescheduleDate, "PP")}
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0">
                      <Calendar mode="single" selected={rescheduleDate} onSelect={(date) => date && setRescheduleDate(date)} initialFocus />
                    </PopoverContent>
                  </Popover>
                </div>
                <div className="space-y-2">
                  <Label className="text-sm">Time</Label>
                  <Input 
                    type="time" 
                    value={rescheduleTime} 
                    onChange={(e) => setRescheduleTime(e.target.value)}
                    className="h-9"
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2 pt-2">
              <Button 
                onClick={handleRescheduleFollowup}
                variant="outline"
                className="w-full"
              >
                <CalendarIcon className="w-4 h-4 mr-2" />
                Reschedule
              </Button>
              {lead?.phone && (
                <Button 
                  onClick={() => {
                    handleClickToCall(lead.phone);
                    setShowDueFollowupPopup(false);
                  }}
                  className="w-full bg-green-600 hover:bg-green-700"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Call Now ({lead.phone})
                </Button>
              )}
              <Button 
                onClick={() => handleCompleteFollowup(dueFollowup.id)}
                variant="ghost"
                className="w-full text-slate-600"
              >
                <Check className="w-4 h-4 mr-2" />
                Mark as Done
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DueFollowupDialog;
